import DeliveryReceiptComponent from "../../Component/DeliveryReceipt/DeliveryReceiptComponent";
const DeliveryReceipt = () => {
  return (
    <>
        <DeliveryReceiptComponent />
    </>
  );
};
export default DeliveryReceipt;
